let headerVue;
document.addEventListener('DOMContentLoaded', function(e) {
    headerVue = Vue.createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                q: '',
                showHeaderBar: true,
                showSearchForm: false,
                activeSubmenu: null,
                showMobileMenu: false,
                hideSiteHeader: false
            }
        },
        mounted() {
            const this_obj = this;

            //-- set simple dropdown position
            this_obj.setSimpleDropdownPos();

            //-- open cart drawer on first load
            const urlSearchParams = new URLSearchParams(window.location.search);
            const param = urlSearchParams.get('drawer');
            if(param == 'true') {
                this_obj.showHeaderCart();
            }

            //-- link back mobile clicked
            const mobile_menu_wrapper = document.querySelector('.mobile-menu-wrapper');
            mobile_menu_wrapper.addEventListener('click', function(event){
                if(event.target.closest('#link-back-mobile')) {
                    event.preventDefault();
                    this_obj.hideMobileMenuDrop(event);
                }

                return false;
            });

            //-- page overlay clicked
            const page_overlay = document.querySelector('.header-overlay');
            page_overlay.addEventListener('click', function(event){
                if(window.innerWidth < 1024) {
                    this_obj.toggleMobileMenu();
                }
                this_obj.showSearchForm = false;
            });

            //-- page overlay global clicked
            const page_overlay_global = document.querySelector('.page-overlay.header-cart-overlay');
            page_overlay_global.addEventListener('click', function(event){
                this_obj.showSearchForm = false;
            });

            //-- header search overlay clicked
            const headerSearchOverlay = document.querySelector('.page-overlay.header-search-overlay');
            if(headerSearchOverlay != null) {
                headerSearchOverlay.addEventListener('click', function(e){
                    this_obj.headerSearchHandler(e);
                });
            }

            //-- set top position
            this_obj.setTopPosition();
            window.addEventListener('resize', function(){
                this_obj.setTopPosition();
            });
            window.addEventListener('scroll', function(){
                this_obj.setTopPosition();
            });


            //-- search view all clicked
            document.addEventListener('click', function(e){
                if(e.target.classList.contains('search-view-all')){
                    e.preventDefault();
                    this_obj.clickViewAll();
                }
            });

            //-- nav on hover
            const navMenu = document.querySelector('#header-con .desktop-menu-wrapper'); 
            const topNav = document.querySelector('#shopify-section-top-nav');
            const header = document.querySelector('#shopify-section-header');
            if(topNav != null) {
                topNav.addEventListener('mouseenter', function(e){
                    header.classList.add('hover');
                    topNav.classList.add('hover');
                });
            }
            if(navMenu != null) {
                navMenu.addEventListener('mouseenter', function(e){
                    header.classList.add('hover');
                    topNav.classList.add('hover');
                });
            }

            header.addEventListener('mouseenter', function(e){
                if(topNav != null) {
                    topNav.classList.add('hover');
                }
                header.classList.add('hover');
            });

            header.addEventListener('mouseleave', function(e){
                const activeOverlay = document.querySelector('.page-overlay.active');

                if(activeOverlay == null) {
                    if(window.scrollY < 150) {
                        if(topNav != null) {
                            topNav.classList.remove('hover');
                        }
                        header.classList.remove('hover');
                    }
                }
            });

            //-- window on scroll event
            window.addEventListener('scroll', function(e){
                if(window.scrollY > 150) {
                    if(topNav != null) {
                        topNav.classList.add('hover');
                    }
                    header.classList.add('hover');
                } else {
                    if(document.querySelector('.menu-dropdown.show') == null) {
                        const activeOverlay = document.querySelector('.page-overlay.active');
                        if(activeOverlay == null) {
                            if(topNav != null) {
                                topNav.classList.remove('hover');
                            }
                            header.classList.remove('hover');
                        }
                    }
                }
            });

            //-- handle overflow shadow for dropdowns
            this_obj.initOverflowShadow();
        },
        methods: {
            setTopPosition() {
                //-- set menu dropdown top position
                const mobileMenuWrapper = document.querySelector('#header-con .mobile-menu-wrapper');
                const mobileDropdownMenu = document.querySelector('#header-con .menu-dropdown-mobile-wrapper');
                const headerMenuHeight = document.querySelector('.site-header .header-con-outer').offsetHeight;
                const overlaySearch = document.querySelector('.header-search-overlay');
                const headerDesktopSearch = document.querySelector('.header-desktop-search');
                const search_result_wrapper = document.querySelector('.sm-search-result');
                const header_desktop_search_form = document.querySelector('.header-desktop-search-form').offsetHeight;
                const popupCart = document.querySelector('#popup-cart');
                
                let topNavHeight = 0;
                if(document.querySelector('#shopify-section-top-nav') != null) {
                    topNavHeight = document.querySelector('#shopify-section-top-nav').offsetHeight;
                }

                //-- set header desktop search position
                
                if(overlaySearch != null) {
                    overlaySearch.style.top = `${(topNavHeight+headerMenuHeight)+1}px`;
                }
                
                if(screen.width < 1024) {
                    const screenHeight = window.innerHeight;
                    if(mobileMenuWrapper != null) {
                        if(window.scrollY < 150) {
                            mobileMenuWrapper.style.top = `${(headerMenuHeight+topNavHeight)-0.5}px`;
                            if(headerDesktopSearch != null) {
                                headerDesktopSearch.style.top = `${(headerMenuHeight+topNavHeight)-0.5}px`;
                            }
                            mobileMenuWrapper.style.height = `${(screenHeight-(headerMenuHeight+topNavHeight))}px`;
                            search_result_wrapper.style.height = `${(screenHeight-(headerMenuHeight+topNavHeight+header_desktop_search_form))-0.5}px`;

                        } else {
                            mobileMenuWrapper.style.top = `${(headerMenuHeight)-0.5}px`;
                            if(headerDesktopSearch != null) {
                                headerDesktopSearch.style.top = `${(headerMenuHeight)-0.5}px`;
                            }
                            mobileMenuWrapper.style.height = `${(screenHeight-(headerMenuHeight))}px`;
                            search_result_wrapper.style.height = `${(screenHeight-(headerMenuHeight+header_desktop_search_form))-0.5}px`;
                        }
                    }

                    if(mobileDropdownMenu != null) {
                        if(window.scrollY < 150) {
                            if($360Shop.is_login) {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight+topNavHeight)-50-45)}px`;
                            } else {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight+topNavHeight)-50)}px`;
                            }
                        } else {
                            if($360Shop.is_login) {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight)-50-45)}px`;
                            } else {
                                mobileDropdownMenu.style.height = `${(screenHeight-(headerMenuHeight)-50)}px`;
                            }
                        }
                    }
                } else {
                    if(popupCart != null) {
                        if(window.scrollY < 150) {
                            popupCart.style.top = `${(topNavHeight+headerMenuHeight)+1}px`;
                        } else {
                            popupCart.style.top = `${(headerMenuHeight)}px`;
                        }
                    }
                }
            },
            toggleCurrencySwitcher(e) {
                e.preventDefault();

                const parent = e.target.closest('.currency-selector');
                if(parent != null) {
                    parent.classList.toggle('active');
                }

                return false;
            },
            changeRightSideContent(e) {
                const elem = e.target;
                const right_side_elem = elem.closest('.menu-dropdown').querySelector('.right-side');
                const submenu_content_title = right_side_elem.querySelector('.submenu-content-title');
                const products_wrapper = right_side_elem.querySelector('.products-wrapper');
                const coll_handle = elem.getAttribute('data-coll-handle');
                const content_title = elem.getAttribute('data-content-title');

                if(coll_handle == '') {
                    submenu_content_title.innerHTML = '';
                    products_wrapper.innerHTML = '';

                    const active_elem = elem.closest('.menu-dropdown').querySelector('.left-side a.active');
                    if(active_elem != null) {
                        active_elem.classList.remove('active');
                    }
                } else {
                    if(!elem.classList.contains('active')) {
                        const active_elem = elem.closest('.menu-dropdown').querySelector('.left-side a.active');
                        if(active_elem != null) {
                            active_elem.classList.remove('active');
                        }

                        elem.classList.add('active');

                        submenu_content_title.innerHTML = content_title;
                        if(content_title == '') {
                            submenu_content_title.classList.remove("mb-28");
                        } else {
                            submenu_content_title.classList.add("mb-28");
                        }

                        products_wrapper.innerHTML = '<p class="p1 pt-32 pb-32 tc w-full show-m"><img width="40" height="40" src="https://cdn.shopify.com/s/files/1/0682/4601/2090/files/200w-ezgif.com-webp-to-gif-converter.gif?v=1732267262" /></p>';

                        axios.get(Shopify.routes.root+`collections/${coll_handle}?view=submenu`)
                        .then(function(response) {
                            const html = document.createRange().createContextualFragment(response.data);
                            products_wrapper.innerHTML = '';
                            products_wrapper.append(html);

                            const delay = setTimeout(() => {
                                $360.lazyLoadInstance.update();
                                
                                clearTimeout(delay);
                            }, 500);
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            },
            changeCountry(iso_code,e) {
                e.preventDefault();
                const country_field = e.target.closest('.currency-selector').querySelector('input[name="country_code"]');
                country_field.value = iso_code;
                country_field.closest('form').submit();

                return false;
            },
            setCookie(name, value, days) {
                let expires = "";
                if (days) {
                    const date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            },
            closeAnnBar(event) {
                event.preventDefault();
                
                /* set cookie expired in 2 days */
                this.setCookie('hide_ann_bar','true',2);
                this.removeAnnBar();
            },
            removeAnnBar() {
                const site_header = document.querySelector('.site-header');
                const ann_bar = document.querySelector('.header-bar');
                const body = document.querySelector('body');
                const global_content_tm = document.querySelector('.global-content-top-margin');

                if(site_header != null) {
                    if(ann_bar != null) {
                        ann_bar.remove();
                    }

                    body.classList.add('no-bar');

                    $360.headerHeight = site_header.querySelector('.header-con-outer').offsetHeight;
                    if(global_content_tm != null) {
                        global_content_tm.style.marginTop = `-${ann_bar.offsetHeight}px`;
                    }

                    if(site_header.classList.contains('transparent')) {
                        const first_section = document.querySelector('.global-content-top-margin .shopify-section:first-child');
                        if(first_section != null) {
                            first_section.style.marginTop = `-${$360.headerHeight+ann_bar.offsetHeight}px`;
                        }
                    }
                }
            },
            headerSearchHandler(event) {
                const this_obj = this;

                if(event != null) {
                    event.preventDefault();
                }

                /* hide menu on mobile */
                if(screen.width < 1024) {
                    const mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper');
                    if(mobileMenuWrapper != null && mobileMenuWrapper.classList.contains('active')) {
                        this_obj.toggleMobileMenu();
                    }
                }

                const body = document.querySelector('body');
                const filter_bar = document.querySelector('#collection-filter');
                const sticky_elem = document.querySelector('.has-sticky-elem');
                const page_overlay_global = document.querySelector('.page-overlay.header-search-overlay');
                
                if(!body.classList.contains('no-overflow')) {
                    /*
                    if(filter_bar != null) {
                        filter_bar.classList.remove('zi-6');
                        filter_bar.classList.add('zi-2');
                    }
                    */
                    body.classList.add('no-overflow');
                    if(sticky_elem != null) {
                        sticky_elem.classList.add('zi-2');
                    }

                    this.showSearchForm = !this.showSearchForm;
                    document.getElementById("search-term").focus();
                } else {
                    // const delay = setTimeout(() => {
                        /*
                        if(filter_bar != null) {
                            filter_bar.classList.remove('zi-2');
                            filter_bar.classList.add('zi-6');
                        }
                        */
                        body.classList.remove('no-overflow');
                        if(sticky_elem != null) {
                            sticky_elem.classList.remove('zi-2');
                        }
                        this.showSearchForm = !this.showSearchForm;
                        
                    //     clearTimeout(delay);
                    // }, 500);
                }

                if(page_overlay_global != null) {
                    page_overlay_global.classList.toggle('active');
                }

                return false;
            },
            handleKeyDown(event) {
                if (event.key === 'Enter') {
                    // Handle special characters like % by encoding them properly
                    let searchValue = document.querySelector('#search-term').value;
                    if (searchValue && typeof searchValue === 'string') {
                        // Replace problematic characters but keep search functionality
                        searchValue = searchValue.replace(/[%]/g, '%25');
                    }
                    window.location.href = `/search?q=${searchValue}&type=product`;
                }
            },
            clickViewAll() {
                // Handle special characters like % by encoding them properly
                let searchValue = document.querySelector('#search-term').value;
                if (searchValue && typeof searchValue === 'string') {
                    // Replace problematic characters but keep search functionality
                    searchValue = searchValue.replace(/[%]/g, '%25');
                }
                window.location.href = `/search?q=${searchValue}&type=product`;
            },
            debounce(func, wait = 200) {
                let timeout;
              
                return function(...args) {
                  clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    func.apply(this, args);
                  }, wait);   
                };
            },
            goSearch() {
                const debouncedSearch = this.debounce(() => {
                    this.goSearchRequest();
                }, 600);
            
                debouncedSearch();
            },
            async goSearchRequest() {
                try {
                    let resultContainer = document.querySelector('#sm-search-result');
                    const search_result_wrapper = document.querySelector('.header-desktop-search .search-result-wrapper');
                                        
                    const req = await $360.getSearchContent('filtered', `${this.q}&type=product`);
                    let {data, status} = req;

                    if(this.q.trim() == '') {
                        // if(search_result_wrapper != null) {
                        //     search_result_wrapper.classList.add('hide-m');
                        // }
                        resultContainer.innerHTML = '';
                    } else {
                        // if(search_result_wrapper != null) {
                        //     search_result_wrapper.classList.remove('hide-m');
                        // }
                        resultContainer.innerHTML = data;
                    }
                    
                    $360.lazyLoadInstance.update();
                } catch (error) {
                    console.log(error)
                }
            },
            setStickyElemsToAbove() {
                const filter_bar = document.querySelector('#collection-filter');
                const sticky_elem = document.querySelector('.has-sticky-elem');

                if(sticky_elem != null) {
                    sticky_elem.classList.remove('zi-2');
                }
            },
            setSimpleDropdownPos() {
                const simple_dropdowns = document.querySelectorAll('.menu-dropdown .simple-dropdown-wrapper');
                simple_dropdowns.forEach(function(dropdown){
                    const parent = dropdown.closest('.menu-dropdown');
                    const li_elem = document.querySelector(`li.parent[data-id="${parent.getAttribute("id")}"]`);

                    if(li_elem != null) {
                        const rect = li_elem.getBoundingClientRect();
                        dropdown.style.left = (rect.left) + 'px';
                    }
                });
            },
            showHeaderCart() {
                $360.showHeaderCart();
            },
            mainNavMouseLeave(e) {
                const delay = setTimeout(() => {
                    const header_links = document.querySelectorAll('.header-nav .header-link');
                    header_links.forEach(function(header_link){
                        header_link.classList.remove('mouseover');
                    });

                    if(window.scrollY < 150 && screen.width > 1023) {
                        if(document.querySelector('#shopify-section-top-nav') != null) {
                            document.querySelector('#shopify-section-top-nav').classList.remove('hover');
                        }
                        document.querySelector('#shopify-section-header').classList.remove('hover');
                    }

                    clearTimeout(delay);
                }, 100);
            },
            showDropdown(num, event) {
                const sticky_elem = document.querySelector('.sticky-header');
                const this_obj = this;
            
                const currentDropdown = document.querySelector(`#header-con .menu-dropdown.show`);
            
                if (currentDropdown && num !== this.activeSubmenu) {
                  currentDropdown.classList.add('waiting-inactive');
            
                  const newDropdown = document.getElementById(`menu-dropdown-${num}`);
                  if (newDropdown) {
                    if (sticky_elem) sticky_elem.classList.add('zi-2');
                    newDropdown.classList.add('show');
                    document.querySelector('.site-header').classList.add('menu-dropdown-show');
                  }
            
                  setTimeout(() => {
                    const waiting = document.querySelector(`#header-con .menu-dropdown.waiting-inactive`);
                    if (waiting) waiting.classList.remove('waiting-inactive');
            
                    document.querySelectorAll(`#header-con .menu-dropdown.show`).forEach(d => {
                      d.classList.remove('show');
                    });
            
                    this_obj.activeSubmenu = num;
            
                    this.$nextTick(() => {
                      this.updateHeaderLinkClasses();
                    });
                  }, 120);
                } else {
                  if (sticky_elem) sticky_elem.classList.add('zi-2');
                  document.querySelector('.site-header').classList.add('menu-dropdown-show');
                  this.activeSubmenu = num;
            
                  this.$nextTick(() => {
                    this.updateHeaderLinkClasses();
                  });
                }
              },
            
              updateHeaderLinkClasses() {
                const links = document.querySelectorAll('.header-link');
                links.forEach(link => {
                  if (link.classList.contains('active')) {
                    link.classList.remove('non-active');
                  } else {
                    link.classList.add('non-active');
                  }
                });
              },
            mobileMenuAccordion(e) {
                if(window.innerWidth < 1024) {
                    $360.accordionToggle(e)
                }
            },
            toggleMobileMenu(e) {
                const iconMenu = document.querySelector('.header-mobile-menu .icon-menu');
                const iconCloseMenu = document.querySelector('.header-mobile-menu .icon-close-menu');
                const body = document.querySelector('body');
                const page_overlay = document.querySelector('.header-overlay');
                const filter_bar = document.querySelector('#collection-filter');
                const sticky_elem = document.querySelector('.has-sticky-elem');
                const mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper');

                let topNavHeight = 0;
                if(document.querySelector('#shopify-section-top-nav') != null) {
                    topNavHeight = document.querySelector('#shopify-section-top-nav').offsetHeight;
                }

                let headerConHeight = 0;
                if(document.querySelector('.header-con__inner') != null) {
                    headerConHeight = document.querySelector('.header-con__inner').offsetHeight;
                }

                if(e != null) {
                    e.preventDefault();
                }

                const topNav = document.querySelector('#shopify-section-top-nav');
                const header = document.querySelector('#shopify-section-header');

                const delayShow = setTimeout(() => {
                    this.showMobileMenu = !this.showMobileMenu;
                    if(this.showMobileMenu) {
                        iconMenu.classList.remove('flex');
                        iconMenu.classList.add('hide-m');
                        iconCloseMenu.classList.remove('hide-m');
                        iconCloseMenu.classList.add('flex');
                        body.classList.add('nooverflow');
                        page_overlay.classList.add('show-mobile');

                        if(topNav != null) {
                            header.classList.add('hover');
                            topNav.classList.add('hover');
                        }
    
                        let delay = setTimeout(() => {
                            page_overlay.classList.add('show-fade');
                            $360.lazyLoadInstance.update();
                            
                            clearTimeout(delay);
                        }, 50);
                    } else {
                        iconMenu.classList.remove('hide-m');
                        iconMenu.classList.add('flex');
                        iconCloseMenu.classList.remove('flex');
                        iconCloseMenu.classList.add('hide-m');
                        body.classList.remove('nooverflow');
                        page_overlay.classList.remove('show-fade');

                        if(window.scrollY < 150) {
                            if(topNav != null) {
                                header.classList.remove('hover');
                                topNav.classList.remove('hover');
                            }
                        }
    
                        let delay = setTimeout(() => {
                            page_overlay.classList.remove('show-mobile');
                            if(sticky_elem != null) {
                                sticky_elem.classList.remove('zi-2');
                            }
                            
                            clearTimeout(delay);
                        }, 500);
                    }
                    
                    clearTimeout(delayShow);
                }, 50);

                return false;
            },
            toggleMobileMenuDrop(e, title) {
                const menu_dropdown_wrapper = document.querySelector('.menu-dropdown-mobile-wrapper');
                let el = e.target.classList.contains('main-menu-title') ? e.target : e.target.closest('.main-menu-title');
                if(el.closest('li').classList.contains('with-children')) {
                    if(!el.closest('.parent').classList.contains('active')) {
                        const active_menu = document.querySelector('.mobile-menu .parent.active');
                        if(active_menu != null) {
                            active_menu.classList.remove('active');
                        }
                        el.closest('.parent').classList.add('active');

                        const active_dropdown = document.querySelector(`.menu-dropdown-mobile-wrapper .mobile-menu-dropdown:not(.hide-m)`);
                        if(active_dropdown != null) {
                            active_dropdown.classList.add('hide-m');
                        }

                        const current_active_dropdown = document.querySelector(`.menu-dropdown-mobile-wrapper .mobile-menu-dropdown[data-title="${title}"]`);
                        if(current_active_dropdown != null) {
                            current_active_dropdown.classList.remove('hide-m');
                        }
                    }
                } else {
                    window.location.href = el.getAttribute('href');
                }

            },
            hideMobileMenuDrop(e) {
                const parent = e.target.closest('.parent'); 
                const dropdown_el = parent.querySelector('.mobile-menu-dropdown');
                const mobile_menu_wrapper = e.target.closest('.mobile-menu-wrapper');
                mobile_menu_wrapper.classList.remove('nooverflow');

                if(parent.classList.contains('submenu-open')) {
                    dropdown_el.classList.remove('show');

                    const delay = setTimeout(() => {
                        dropdown_el.classList.add('hide-m');
                        parent.classList.remove('submenu-open');     
                        
                        clearTimeout(delay);
                    }, 300);
                }
            },
            initOverflowShadow() {
                const this_obj = this;
                
                // Handle scroll for each dropdown with overflow shadow
                const handleDropdownScroll = (dropdown) => {
                    const shadow = dropdown.querySelector('.overflow-shadow');
                    if (!shadow) return;

                    // Check if the menu-dropdown itself has overflow
                    const hasOverflow = dropdown.scrollHeight > dropdown.clientHeight;
                    
                    if (!hasOverflow) {
                        shadow.style.opacity = '0';
                        return;
                    }

                    // Show shadow initially if there's overflow
                    shadow.style.opacity = '1';

                    // Remove existing scroll listener if any
                    if (dropdown._scrollHandler) {
                        dropdown.removeEventListener('scroll', dropdown._scrollHandler);
                    }

                    // Handle scroll event
                    const onScroll = () => {
                        const scrollTop = dropdown.scrollTop;
                        const scrollHeight = dropdown.scrollHeight;
                        const clientHeight = dropdown.clientHeight;
                        const scrollBottom = scrollHeight - scrollTop - clientHeight;

                        // Hide shadow when scrolled to bottom (within 5px threshold)
                        if (scrollBottom <= 5) {
                            shadow.style.opacity = '0';
                        } else {
                            shadow.style.opacity = '1';
                        }
                    };

                    // Store reference to remove later if needed
                    dropdown._scrollHandler = onScroll;
                    dropdown.addEventListener('scroll', onScroll);
                };

                // Observe when dropdowns become visible
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.attributeName === 'class') {
                            const dropdown = mutation.target;
                            if (dropdown.classList.contains('show')) {
                                // Small delay to ensure content is rendered
                                setTimeout(() => {
                                    handleDropdownScroll(dropdown);
                                }, 50);
                            }
                        }
                    });
                });

                // Observe all menu dropdowns
                const dropdowns = document.querySelectorAll('.menu-dropdown');
                dropdowns.forEach((dropdown) => {
                    observer.observe(dropdown, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                });
            }
        }
    });

    headerVue.mount('#header-con');
});